import { setTerms } from './helpers';

export const setStarRating = setTerms('star_rating');
